<template>
  <div ref="contents" class="contentStyle">
    <transition name="fade">
      <router-view v-on:window-open="windowOpen" />
    </transition>
  </div>
</template>

<script>
export default {
  methods: {
    windowOpen: function() {
      this.$emit("window-open");
    }
  }
};
</script>
<style lang="scss">
.contentStyle {
  min-height: 750px;
}
@media screen and (max-width: 900px) {
  .contentStyle {
    min-height: 700px;
  }
}
</style>
